<template>
    <div>
        <div class="h6 mb-0">
            <span
                class="collapse-icon text-dark mr-1"
                :class="article.related_media_visible ? null : 'collapsed'"
                :aria-expanded="article.related_media_visible ? 'true' : 'false'"
                @click="toggleVisibility"
            >
                <span class="open">
                    <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                </span>
                <span class="closed">
                    <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                </span>
                Related Media
            </span>
        </div>

        <b-collapse
            v-model="article.related_media_visible"
            :class="article.related_media_visible ? null : 'collapsed'"
        >
            <div v-if="article.related_media_visible">
                <div v-if="related_media_loading">
                    <div class="m-3">
                        <content-placeholders>
                            <content-placeholders-text :lines="3" />
                        </content-placeholders>
                    </div>
                </div>
                <div v-else>
                    <div v-if="publication_related_media && publication_related_media.length" class="my-3">
                        <div v-if="article.related_media_intro_video_id">
                            <a
                                href="#"
                                v-scroll-to="{
                                    el: '#related-media-item' + article.related_media_intro_video_id,
                                    offset: -144
                                }"
                            >Intro Video</a>
                            <span class="text-muted ml-1">ID: {{ article.related_media_intro_video_id }}</span>
                        </div>
                        <div v-else class="text-danger">
                            No Intro Video selected
                        </div>
                    </div>

                    <div v-if="publication_related_media && publication_related_media.length"
                         class="my-2 border-left pl-3">
                        <div v-for="(item, index) in publication_related_media" :key="index" class="related-media-item">
                            <related-media-item
                                :id="'unit' + unit.id + 'article' + article.id + 'related_media' + item.id"
                                :publication="publication"
                                :article="article"
                                :related_media_items="publication_related_media"
                                :item="item"
                                :type="'related_media'"
                                :disabled="disabled"
                            />
                        </div>
                    </div>

                    <b-alert
                        variant="danger"
                        :show="!publication_related_media || publication_related_media && !publication_related_media.length"
                        class="my-2"
                    >
                        No Related Media added
                    </b-alert>

                    <div class="d-flex">
                        <div class="ml-auto">
                            <b-input-group class="pr-3" size="sm">
                                <b-form-input
                                    placeholder="SBP Media ID"
                                    v-model="quickAddMediaId"
                                    :disabled="disabled"
                                />
                                <b-input-group-append>
                                    <b-button
                                        variant="outline-success"
                                        @click="quickAddMedia"
                                        :disabled="disabled"
                                    >
                                        Quick add
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                        <div>
                            <b-dropdown
                                size="sm"
                                variant="outline-primary"
                                dropup
                                right
                                :disabled="disabled"
                            >
                                <template #button-content>
                                    <font-awesome-icon :icon="['fad', 'plus-square']" />
                                    Add Related Media
                                </template>
                                <b-dropdown-item
                                    @click.prevent="addExistingRelatedMedia"
                                    :disabled="disabled"
                                >
                                    <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary"
                                                       fixed-width />
                                    Add existing related media
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </b-collapse>

        <add-related-media-modal
            v-model="show_add_related_media_modal"
            :publication="publication"
            :article="article"
            :article_related_media="article.related_media"
            @link="linkRelatedMediaItem"
            @unlink="unlinkItem"
            @hide="show_add_related_media_modal = false"
        />
    </div>
</template>

<style lang="scss" scoped>
.related-media-item + .related-media-item {
    margin-top: 0.5rem;
}
</style>

<script>
import {mapState} from 'vuex'

import RelatedMediaItem from '@/components/article/related_media/Item'

import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'

export default {
    data: () => ({
        type: null,
        related_media_loading: false,
        show_add_related_media_modal: false,
        quickAddMediaId: null,
    }),
    props: {
        'unit': Object,
        'publication': Object,
        'article': Object,
        'disabled': {
            type: Boolean,
            default: false,
        },
    },
    components: {
        RelatedMediaItem,
        AddRelatedMediaModal,
    },
    computed: {
        ...mapState({}),
        publication_related_media() {
            return _.filter(this.article.related_media, item => {
                if (
                    !item.pivot ||
                    (item.pivot && item.pivot.publication_id == this.publication.id)
                ) {
                    return item
                }
            })
        }
    },
    watch: {
        'article.related_media_visible': {
            handler(visible) {
                if (visible) {
                    this.getRelatedMedia()
                }
            }
        },
    },
    methods: {
        quickAddMedia() {
            this.linkRelatedMediaItem({id: this.quickAddMediaId})
            this.quickAddMediaId = null
        },
        getRelatedMedia() {
            this.related_media_loading = true

            this.axios.get('/api/articles/related_media/' + this.article.id)
                .then(response => {
                    let related_media = []

                    if (response.data) {
                        related_media = _.uniqBy(response.data, 'id')
                        related_media = _.orderBy(response.data, 'created')

                        this.$set(this.article, 'related_media', related_media)
                    }
                    //this.getExploreMore()
                    this.related_media_loading = false
                })
                .catch(error => {
                    if (error) {
                        console.log(error)

                        this.related_media_loading = false
                        if (
                            error.response &&
                            error.response.status &&
                            error.response.status == 401
                        ) {
                            this.related_media_visible = false
                        }
                    }
                })
        },

        addExistingRelatedMedia() {
            this.show_add_related_media_modal = true
        },
        linkRelatedMediaItem(item) {
            this.axios.post('/api/articles/add_related_media/' + this.article.id, {
                publication_id: this.publication.id,
                related_media_id: item.id
            })
                .then(() => {
                    this.getRelatedMedia()
                })
        },
        unlinkItem(item) {
            let id = item.id
            let related_media_item = {}

            if (item.dam_id) {
                id = item.dam_id
            } else if (item.merlinid) {
                id = item.merlinid
            }
            _.forEach(this.article.related_media, rm_item => {
                if (rm_item.dam_id == id) {
                    id = rm_item.id
                }
            })
            this.axios.post('/api/articles/remove_related_media/' + this.article.article_id, {
                publication_id: this.publication.id,
                related_media_id: id
            })
                .then(() => {
                    this.$set(item, 'linked', false)

                    this.getRelatedMedia()
                })
        },
        toggleVisibility() {
            if (this.article.related_media_visible) {
                this.$set(this.article, 'related_media_visible', false)
            } else {
                this.$set(this.article, 'related_media_visible', true)
            }
        },
    }
}
</script>
